import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Table,
  Select,
  Typography,
  Space,
  InputNumber,
} from "antd";
import { useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { rule_number, rule_require } from "../../../shared/validateInput";
import moment from "moment";
import { getAllVehicleWithoutPagination } from "../../../shared/api/Vehicle";
import { REPAIR_TYPE } from "../../../shared/define";
import { createRepair, getAllRouteWithDate } from "../../../shared/api/Repair";
import MomentDatePicker from "../../../Components/MomentDatePicker";
import { PermissionDirect } from "../../../Components";
import { useRequestLock } from "../../../shared/hooks/useRequestLock";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};
const { Title } = Typography;
const { Option } = Select;
const { Search } = Input;
const repairCreateRequestKey = "repair:create";
function RepairCreate() {
  const history = useHistory();
  const [form] = Form.useForm();
  const { isLocked, runLocked } = useRequestLock();
  const isSaving = isLocked(repairCreateRequestKey);
  const [vehicleId, setVehicleId] = useState("");
  const [orderList, setOrderList] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [repairType, setRepairType] = useState("");
  const [selectedRoute, setSelectRoute] = useState("");
  useEffect(() => {
    loadData();
  }, []);
  const loadData = async () => {
    const response = await getAllVehicleWithoutPagination();
    if (response.success) {
      setVehicleList(response.data);
    }
  };
  const onSelectVehicle = async (id: any) => {
    setIsLoading(true);
    setVehicleId(id);
    const date = moment(form.getFieldValue("date")).format("MM-DD-YYYY");
    const response = await getAllRouteWithDate(id, date);
    if (response.success) {
      setOrderList(response.data);
    }
    setIsLoading(() => false);
  };
  const handleChangeDate = async (value: any) => {
    if (value) {
      const date = moment(value).format("MM-DD-YYYY");
      const res = await getAllRouteWithDate(vehicleId, date);
      if (res.success) {
        setOrderList(res.data);
      }
    } else {
      onSelectVehicle(vehicleId);
    }
  };
  const columns: Array<object> = [
    {
      title: "Ngày",
      dataIndex: "receipt",
      render: (receipt: any) => moment(receipt?.[0]?.time).format("DD/MM/YYYY"),
    },
    {
      title: "Mã đơn",
      dataIndex: "code",
    },
    {
      title: "Tên khách hàng",
      dataIndex: ["order", "customer", "name"],
    },
    {
      title: "Số cont",
      dataIndex: "container",
    },
    {
      title: "Điểm bốc hàng",
      dataIndex: "receipt",
      render: (item: any) => item?.[0].text,
    },
    {
      title: "Điểm dỡ hàng",
      dataIndex: "delivery",
      render: (item: any) => item?.[0].text,
    },
  ];
  const onCreate = async () => {
    await runLocked(repairCreateRequestKey, async () => {
      const res = await createRepair({
        ...form.getFieldsValue(),
        ...(selectedRoute && { route: { _id: selectedRoute } }),
      });
      if (res.success) history.push("/operation/repair");
    });
  };
  const handleBack = () => {
    if (isLocked(repairCreateRequestKey)) return;
    history.goBack();
  };
  return (
    <PermissionDirect screen={["REPAIRS"]} action="add">
      <div
        style={{
          minHeight: "calc(100vh - 70px)",
          position: "relative",
          background: "#fff",
        }}
      >
        <div className="container">
          <Row style={{ width: "100%" }}>
            <Title
              level={5}
              style={{
                marginBottom: "25px",
                cursor: isSaving ? "not-allowed" : "pointer",
                opacity: isSaving ? 0.5 : 1,
              }}
            >
              <span onClick={handleBack} aria-disabled={isSaving}>
                <LeftOutlined />
                Quay lại
              </span>
            </Title>
            <Form
              form={form}
              {...layout}
              style={{ width: "100%" }}
              onFinish={onCreate}
            >
              <Row gutter={[32, 0]} style={{ width: "100%" }}>
                <Col span={8}>
                  <Form.Item
                    label="Tên sửa chữa"
                    name="name"
                    rules={[rule_require]}
                  >
                    <Input placeholder="Tên" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Giá tiền"
                    name="amount"
                    rules={[rule_require]}
                  >
                    <InputNumber
                      formatter={(value) =>
                        ` ${value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} `
                      }
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Ngày sửa chữa"
                    name="date"
                    rules={[rule_require]}
                  >
                    <MomentDatePicker
                      format="DD/MM/YYYY"
                      onChange={(value) => handleChangeDate(value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Chọn xe"
                    name={["vehicle", "_id"]}
                    rules={[rule_require]}
                  >
                    <Select onSelect={(value: any) => onSelectVehicle(value)}>
                      {vehicleList.map((item: any) => (
                        <Option value={item._id} key={item._id}>
                          {item.licensePlate}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Loại sửa chữa"
                    name="type"
                    rules={[rule_require]}
                  >
                    <Select onSelect={(value: any) => setRepairType(value)}>
                      {REPAIR_TYPE.map((item: any) => (
                        <Option value={item.value} key={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {(repairType == "BIG" ||
                  repairType == "TIRE" ||
                  repairType == "TOOLS") && (
                  <Col span={8}>
                    <Form.Item
                      label="Thời gian khấu hao"
                      name="amortizationPeriod"
                      rules={[rule_number]}
                    >
                      <Input suffix="Tháng" />
                    </Form.Item>
                  </Col>
                )}
                {repairType == "SMALL" && (
                  <Col span={24}>
                    <Space
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 16,
                      }}
                    >
                      <Title level={5}>Thông tin đơn chạy</Title>
                    </Space>
                    <Table
                      rowSelection={{
                        type: "radio",
                        onSelect: (record: any) => {
                          setSelectRoute(record._id);
                        },
                      }}
                      columns={columns}
                      rowKey={(order: any) => order._id}
                      dataSource={orderList}
                      loading={isloading}
                    />
                  </Col>
                )}
              </Row>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} offset={16}>
                <Button
                  loading={isSaving}
                  disabled={isSaving}
                  htmlType="submit"
                  style={{
                    width: "100%",
                    backgroundColor: "#03A9F4",
                    color: "white",
                  }}
                >
                  Thêm chi phí sửa chữa
                </Button>
              </Col>
            </Form>
          </Row>
        </div>
      </div>
    </PermissionDirect>
  );
}

export default RepairCreate;
